module.exports = __webpack_public_path__ + "static/media/history-view.910169d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/history-view.jpg
// module id = 1042
// module chunks = 0